<template>
  <Page :page-name="pageName" :table="table" :pagination="pagination" :search-bar="searchBar">
    <div slot="operate-bar" class="operate-bar">
      <el-button type="primary" @click="jumpConfigPage()">添加</el-button>
    </div>
    <div slot="signUpTime" slot-scope="{scope}">
      <span>{{scope.registrationStartTime}} - {{scope.registrationEndTime}}</span>
    </div>
    <div slot="beginTime" slot-scope="{scope}">
      <span>{{scope.activityStartTime}} - {{scope.activityEndTime}}</span>
    </div>
    <div slot="publishStatus" slot-scope="{scope}">
      <span>{{ scope.publishStatus | publishStatusFilter }}</span>
    </div>
    <template slot="table-operate" slot-scope="{scope}">
      <el-button v-if="[0, 2].includes(scope.publishStatus)" type="text" slot="reference" @click="jumpConfigPage(scope.id, 'publish')" v-show="scope.publishStatus != 2">发布</el-button>
      <el-button v-if="[1].includes(scope.publishStatus)" type="text" slot="reference" style="color: #f33458;" @click="activityOperate(scope)">下架</el-button>
      <el-button v-if="[0].includes(scope.publishStatus)" type="text" @click="jumpConfigPage(scope.id)">编辑</el-button>
      <el-button type="text" @click="jumpConfigPage(scope.id, scope.publishStatus?'publishLook':'look')">查看</el-button>
      <el-button v-if="[0, 2].includes(scope.publishStatus)" type="text" slot="reference" style="color: #f33458;" @click="activityDelete(scope.id)">删除</el-button>
      <el-button v-if="[1].includes(scope.publishStatus)" type="text" @click="activityUserOrder(scope.id)">报名名单</el-button>
      <el-button v-if="[1].includes(scope.publishStatus)" type="text" @click="joinUserList(scope.id)">活动名单</el-button>
    </template>
    <!-- 报名名单 -->
    <Dialogs title="报名名单" :is-show-dialog.sync="isShowPage" width="50%" @handleClick="handleClose">
      <div slot="content">
        <UserList :activityId="activityId" :isShowPage.sync="isShowPage" ref="userList"/>
      </div>
    </Dialogs>
    <!-- 活动名单 -->
    <Dialogs title="活动名单" :is-show-dialog="isShowMark" width="50%" @handleClick="saveMark">
      <div slot="content">
        <JoinUserList :activityId="activityId" :isShowMark.sync="isShowMark" ref="jonUserList"/>
      </div>
    </Dialogs>
  </Page>
</template>

<script>
import Page from '@/components/Page.vue'
import Dialogs from '@/components/page/Dialogs.vue'
import UserList from './userList.vue'
import JoinUserList from './JoinUserList.vue'
import { getActivityList, activityOperate, activityDelete } from '@/api/activity'
const initParams = {
  current: 1,
  size: 10,
  activityName: '',
  status: ''
}

export default {
  components: {
    Page,
    Dialogs,
    UserList,
    JoinUserList
  },
  filters: {
    publishStatusFilter (val) {
      switch (val) {
        case 0:
          return '未发布'
        case 1:
          return '已发布'
        case 2:
          return '已下架'
      }
    }
  },
  data () {
    return {
      activityId: '',
      isShowMark: false,
      params: {...initParams},
      pageName: '活动管理',
      isShowPage: false,
      table: {
        selection: false, // 是否开启选择框
        index: true,
        // disableKey: 'xxx', // 是否可勾选字段
        tableInfo: [{
          key: 'name',
          name: '标题',
          minWidth: 80
        }, {
          key: 'coverImageUrl',
          name: '图片',
          minWidth: 100,
          type: 'img',
          width: '80px',
          height: '40px'
        }, {
          key: 'signUpTime',
          name: '报名时间',
          minWidth: 120,
          type: 'custom'
        }, {
          key: 'beginTime',
          name: '活动时间',
          minWidth: 120,
          type: 'custom'
        }, {
          key: 'publishUserName',
          name: '增加人',
          minWidth: 60
        }, {
          key: 'updateTime',
          name: '增加时间',
          minWidth: 80
        }, {
          type: 'custom',
          key: 'publishStatus',
          name: '状态',
          minWidth: 80
        }],
        tableData: [],
        deleteList: (list) => {
          console.log(list)
        }
      },
      pagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        currentChange: (page) => {
          this.searchType(page)
        },
        sizeChange: (pageSize) => {
          this.params.size = pageSize
          this.searchType()
        }
      },
      searchBar: {
        list: [{
          type: 'input',
          prop: 'activityName',
          label: '标题',
          placeholder: '请输入活动标题'
        }, {
          type: 'select',
          prop: 'status',
          label: '状态',
          // valueKey: '',
          // labelKey: '',
          options: [{
            value: 0,
            label: '未发布'
          }, {
            value: 1,
            label: '已发布'
          }, {
            value: 2,
            label: '已下架'
          }],
          placeholder: '请选择活动状态'
        }, {
          type: 'btn',
          text: '搜索',
          btnType: 'primary',
          callback: (params) => {
            this.params = { ...this.params, ...params }
            this.searchType(1)
          }
        }, {
          type: 'btn',
          text: '重置',
          btnType: 'primary',
          isReset: true,
          callback: this.resetList
        }]
      }
    }
  },
  async mounted () {
    this.initData()
  },
  methods: {
    handleClose (bol) {
      if (bol) {
        this.$refs.userList.save()
      } else {
        this.isShowPage = false
      }
    },
    saveMark (bol) {
      if (bol) {
        this.$refs.jonUserList.save()
      } else {
        this.isShowMark = false
      }
    },
    removeNullParam (params) {
      for (const key in params) {
        if (params[key] !== 0 && !params[key]) {
          delete params[key]
        }
      }
      return params
    },
    async initData () {
      const { data = {} } = await getActivityList(this.removeNullParam(this.params))
      const { records = [], total = 0 } = data
      this.$set(this.table, 'tableData', records)
      this.$set(this.pagination, 'total', total)
    },
    activityUserOrder (id) {
      this.activityId = id
      this.isShowPage = true
    },
    joinUserList (id) {
      this.activityId = id
      this.isShowMark = true
    },
    activityOperate (scope) {
      this.$confirm('确定要下架吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const {id, publishStatus} = scope
        await activityOperate({
          id,
          publishStatus: +!publishStatus
        })
        this.$message({
          type: 'success',
          message: '下架成功!'
        })
        this.searchType()
      }).catch(() => {

      })
    },
    activityDelete (id) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await activityDelete(id)
        this.$message.success('删除成功')
        this.searchType()
      }).catch(() => {

      })
    },
    searchType (page = 0) {
      if (page) this.pagination.currentPage = page
      this.params.current = page
      this.initData()
    },
    resetList () {
      this.params = {...initParams}
      this.searchType()
    },
    jumpConfigPage (id = '', type) {
      if (id) {
        if (type === 'publish') {
          this.$router.push(`contentConfigPage?sourceType=3&id=${id}&type=publish`)
        } else if (type === 'publishLook') {
          this.$router.push(`contentConfigPage?sourceType=3&id=${id}&type=publishLook`)
        } else if (type === 'look') {
          this.$router.push(`contentConfigPage?sourceType=3&id=${id}&type=look`)
        } else {
          this.$router.push(`contentConfigPage?sourceType=3&id=${id}`)
        }
      } else {
        this.$router.push('contentConfigPage?sourceType=3')
      }
    }
  }
}
</script>

<style lang="scss">
  .dialog-box {
    height: 70%;
  }
</style>
